import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

const STORAGE_KEY = '__admin_impersonate_restore';

export function ImpersonationBanner() {
  const [restore, setRestore] = useState<{ access_token: string; refresh_token: string; email: string } | null>(null);
  const [restoring, setRestoring] = useState(false);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) setRestore(JSON.parse(raw));
    } catch { /* ignore */ }
  }, []);

  if (!restore) return null;

  async function exitImpersonation() {
    if (!restore) return;
    setRestoring(true);
    try {
      await supabase.auth.setSession({
        access_token:  restore.access_token,
        refresh_token: restore.refresh_token,
      });
      sessionStorage.removeItem(STORAGE_KEY);
      window.location.href = '/admin-ap/users';
    } catch {
      setRestoring(false);
    }
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 99998,
      backgroundColor: '#b45309',
      color: '#fff',
      padding: '0.5rem 1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      fontSize: '13px',
      fontWeight: 600,
    }}>
      <span>⚠️ Modo impersonação ativo, você está visualizando a conta de outro usuário</span>
      <button
        onClick={exitImpersonation}
        disabled={restoring}
        style={{
          backgroundColor: '#fff',
          color: '#b45309',
          border: 'none',
          borderRadius: '4px',
          padding: '0.25rem 0.75rem',
          fontWeight: 700,
          fontSize: '12px',
          cursor: restoring ? 'not-allowed' : 'pointer',
          opacity: restoring ? 0.7 : 1,
          whiteSpace: 'nowrap',
        }}
      >
        {restoring ? 'Restaurando...' : `↩ Voltar ao Admin (${restore.email})`}
      </button>
    </div>
  );
}
